"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createRef() {
    var ref = function (refElement) {
        if (refElement === void 0) { refElement = null; }
        ref.current = refElement;
    };
    ref.current = null;
    Object.seal(ref);
    return ref;
}
exports.default = createRef;
//# sourceMappingURL=index.js.map